"use client";

import { PropsWithChildren, useEffect, useRef, useState } from "react";

export default function StickyOnScroll({ children }: PropsWithChildren) {
  const stickyElement = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll: IntersectionObserverCallback = (entries) => {
    entries.forEach((entry) => {
      setIsSticky(
        entry.boundingClientRect.top < 0 && entry.intersectionRatio == 0
      );
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleScroll, {
      root: null,
      rootMargin: "200px 0px 0px 0px",
    });
    const currentElement = stickyElement.current;

    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  return (
    <>
      <div className={`sticky-on-scroll ${isSticky ? "sticky" : ""}`}>
        {children}
      </div>
      <div className="sticky-on-scroll-reference" ref={stickyElement}></div>
    </>
  );
}
